import { Link } from 'react-router-dom';

const CONTACT_NPUB = 'npub17yz39h76u6kltj9kzw7jus3mgpv0ep3dwsef80aqs3clejff8wesmfa6q6';

export function ContactFooter() {
  return (
    <footer className="mx-auto w-full max-w-7xl px-5 pb-6 pt-8 text-center text-xs text-muted-foreground sm:px-8">
      Questions or comments?{' '}
      <Link className="font-medium text-violet-400 underline-offset-4 hover:underline" to={`/${CONTACT_NPUB}`}>
        Contact Jody on Nostr
      </Link>
    </footer>
  );
}
